import React from 'react';
import Panel from '../components/Panel';
import Input from '../components/Input';
import InputFile from '../components/InputFile';
import helpers from '../lib/helpers';
import store, {actions} from '../store';
import auth from '../lib/auth';
import InputSelect from '../components/InputSelect';
import _ from 'lodash';

export default class DiscussionEdit extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      initializing: true,
      submitting: false,
      deleting: false,
      data: {},
      selectedGroup: {},
    };

    this.handleGroupSelect = this.handleGroupSelect.bind(this);
    this.handleSubscriberSelect = this.handleSubscriberSelect.bind(this);
    this.save = this.save.bind(this);
    this.remove = this.remove.bind(this);
    this.hasControl = this.hasControl.bind(this);
  }

  async componentDidMount() {
    let discussionId = this.props.match.params.discussionId;
    let tasks = [
      auth.user(),
      store.dispatch(actions.groups.fetchAll()),
      store.dispatch(actions.users.fetchAll()),
      discussionId ?
          store.dispatch(actions.discussions.fetch(discussionId)) :
          () => {
            return {
              userId: user.id,
            };
          },
    ];

    if (this.props.match.params.discussionId) {
    }
    let [user, groups, users, data] = await Promise.all(tasks);

    this.user = user;
    this.users = _.reduce(users, (container, user) => {
      container[user.userId] = user;
      return container;
    }, {});

    data.subscribers = _.compact(_.map(data.subscribers, (subscriberId) => {
      return this.users[subscriberId];
    }));

    this.setState({
      initializing: false,
      user,
      groups,
      users,
      data,
    });
  }

  isValid() {
    let data = this.state.data;
    if(_.isEmpty(data.subscribers) && this.user.isAdmin){
      return false;
    }
    return !_.isEmpty(data.name) && !_.isEmpty(data.subject);
  }

  save() {
    this.setState({
      submitting: true,
    });

    let data = Object.assign({}, this.state.data);
    delete data.items;
    data.subscribers = _.map(data.subscribers,
        (subscriber) => subscriber.userId);

    if(_.isEmpty(data.subscribers)){
      data.subscribers = [this.user.id];
    }
    data.hidediscussion = !!data.hidediscussion;
    data.attachments = data.attachments || [];

    store.dispatch(actions.discussions.createOrUpdate(data)).
        then((result) => {
          let discussionId = this.state.data.discussionId ||
              result.discussionId;
          this.props.history.push(`/discussions/${discussionId}`);
        }).
        catch(err => {
          alert(err.message);
          this.setState({
            submitting: false,
          });
        });
  }

  remove() {
    this.setState({
      deleting: true,
    });

    store.dispatch(actions.discussions.remove(this.state.data.discussionId)).
        then((result) => {
          this.props.history.push(`/discussions`);
        }).
        catch(err => {
          alert(err.message);
          this.setState({
            deleting: false,
          });
        });
  }

  handleGroupSelect(group) {

    let groupMembers = group && group.value ?
        _.map(group.value.users, (userId) => {
          return _.find(this.state.users, (user) => {
            return user.userId === userId;
          });
        }) :
        [];
    this.setState({
      selectedGroup: group,
      data: Object.assign({}, this.state.data, {
        subscribers: _.uniqBy(
            (this.state.data.subscribers || []).concat(groupMembers), 'userId'),
      }),
    });
  }

  handleSubscriberSelect(data) {
    this.setState({
      data: Object.assign({}, this.state.data, {
        subscribers: _.map(data, (item) => item.value),
      }),
    });
  }

  handleFormChange(name, value) {
    this.setState({
      data: Object.assign({}, this.state.data, {
        [name]: value,
      }),
    });
  }

  hasControl(){
    return !this.state.data.discussionId || (this.state.data.userId === this.user.id) || this.user.isAdmin;
  }

  render() {
    return this.state.initializing ? helpers.showPanelLoading() : !this.hasControl() ? helpers.showPageNotFound() : (
        <Panel title={this.state.data.discussionId ?
            'Edit Discussion' :
            'New Discussion'}>
          <Input label="Discussion Name"
                 value={this.state.data.name || ''}
                 onChange={this.handleFormChange.bind(this, 'name')}
          />
          <Input label="Discussion Subject"
                 value={this.state.data.subject || ''}
                 onChange={this.handleFormChange.bind(this, 'subject')}
          />
          <InputFile label="Attachments"
                     multi
                     value={this.state.data.attachments || ''}
                     onChange={this.handleFormChange.bind(this, 'attachments')}
          />

          {
            this.user.isAdmin ? [
              <InputSelect
                  key="groups"
                  label="User Group"
                  options={_.map(this.state.groups, (group) => {
                    return {
                      label: group.groupName,
                      value: group,
                    };
                  })}
                  onChange={this.handleGroupSelect}
                  value={this.state.selectedGroup}
              />,
              <InputSelect
                  key="users"
                  label="Subscribers"
                  multi
                  options={_.map(this.state.users, (user) => {
                    return {label: user.nickname || user.email, value: user};
                  })}
                  value={_.map(this.state.data.subscribers, (user) => {
                    return {label: user.nickname || user.email, value: user};
                  })}
                  onChange={this.handleSubscriberSelect}
              />,
              <Input
                  key="hidediscussion"
                  type="checkbox"
                  label="Hide from Clients"
                  checked={this.state.data.hidediscussion || false}
                  onChange={this.handleFormChange.bind(this, 'hidediscussion')}
              />,
            ] : null
          }
          <div className="container-fluid clearfix" style={{
            borderTop: '1px solid #ccc',
            padding: '30px 60px 10px',
            margin: '0 -20px',
            width: 'auto',
          }}>
            {
              this.state.data.discussionId ?
                  (<button className="btn btn-outline-danger pull-left px-5"
                           disabled={this.state.submitting ||
                           this.state.deleting}
                           onClick={this.remove}
                  >
                    {this.state.deleting ? 'Deleting...' : 'Delete'}
                  </button>) : null
            }
            <button className="btn btn-purple pull-right px-5"
                    disabled={this.state.submitting || this.state.deleting ||
                    !this.isValid()}
                    onClick={this.save}
            >
              {this.state.data.discussionId ? 'Save' : 'Create'}
            </button>
          </div>
        </Panel>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/DiscussionEdit.js